"use strict";

var React = require("react");

var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

var Layout = preferDefault(require(GATSBY_LAYOUT_COMPONENT_PATH)); // eslint-disable-next-line react/prop-types,react/display-name

module.exports = function (_ref) {
  var element = _ref.element,
      props = _ref.props;
  return React.createElement(Layout, props, element);
};